import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyBf4BndRMicxE9J4tIdvBfXZD7IRRR1tYo',
  authDomain: 'jobseeqr.co',
  projectId: 'jobseeqr',
  databaseURL: 'https://jobseeqr.firebaseio.com',
  storageBucket: 'jobseeqr.appspot.com',
  messagingSenderId: '435586021357',
  appId: '1:435586021357:web:5a192f0a7fd6100a71d9e4'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);

// Initialize Firebase Storage and get a reference to the service
const storage = getStorage(app);

export { auth, database, storage };

export default app; 